import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '@/lib/firebase';

export type ActivityAction =
  | 'product_created'
  | 'product_edited'
  | 'product_deleted'
  | 'stock_increased'
  | 'stock_decreased'
  | 'quotation_created'
  | 'customer_created'
  | 'store_updated';

export type ActivityEntityType =
  | 'product'
  | 'quotation'
  | 'customer'
  | 'store'
  | 'stock';

export interface ActivityLogEntry {
  action: ActivityAction;
  title: string;
  description: string;
  actorId: string | null;
  actorName: string | null;
  entityType: ActivityEntityType;
  entityId: string;
  metadata?: Record<string, unknown>;
}

/**
 * Writes an activity log entry to the `activity_logs` Firestore collection.
 * Fire-and-forget — errors are silently caught to avoid blocking the caller.
 */
export async function logActivity(entry: ActivityLogEntry): Promise<void> {
  try {
    const clean: Record<string, unknown> = { ...entry };
    // Strip undefined values
    for (const key of Object.keys(clean)) {
      if (clean[key] === undefined) delete clean[key];
    }
    await addDoc(collection(db, 'activity_logs'), {
      ...clean,
      createdAt: serverTimestamp(),
    });
  } catch (err) {
    // Silently fail — activity logs should never block user workflows
    console.warn('Failed to write activity log:', err);
  }
}
